import { render, staticRenderFns } from "./UpdateAwardOrder.vue?vue&type=template&id=94d7bcba&scoped=true"
import script from "./UpdateAwardOrder.vue?vue&type=script&lang=js"
export * from "./UpdateAwardOrder.vue?vue&type=script&lang=js"
import style0 from "./UpdateAwardOrder.vue?vue&type=style&index=0&id=94d7bcba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d7bcba",
  null
  
)

export default component.exports